var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVideoOn = function SvgVideoOn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M21.712 10.417V5.944c0-.702-.587-1.277-1.305-1.277H4.757c-.718 0-1.305.575-1.305 1.277v12.778c0 .703.587 1.278 1.305 1.278h15.65c.718 0 1.305-.575 1.305-1.278V14.25l2.986 2.926c.822.805 2.23.23 2.23-.907V8.385c0-1.137-1.408-1.712-2.23-.907l-2.986 2.939z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0,
    d: "M0 0H29V24H0z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVideoOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/video-on.584a04e5cd00a586093c3bf64ef71b84.svg";